import Slider from "react-slick";
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import { partners } from '../../data';
import './partners.scss';

const Partners = () => {
  const { t } = useTranslation();

  const settings = {
    arrows: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
    {
        breakpoint: 768,
        settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        }
    },
    {
        breakpoint: 475,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1
        }
    },
    {
        breakpoint: 350,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
        }
    }
    ]
};

    return (
      <>
<div className="partners container">
          <div className="partners__collection">
                    <h1>{t('partners.title')}</h1>
      <div className="partners__row1">
              <Slider {...settings}>
                {partners.map((partner, index) => (
                  <div key={index}>
                    <img src={images[partner.imageKey]} alt={t(`data.partners.${partner.imageKey}`)} />
                  </div>
                ))}
              </Slider>
                    </div>
                    </div>
</div>
</>
)
}

export default Partners;